import axios from "../axios";

export async function fetchDrivingTrips(controller) {
  return axios({
    method: "get",
    url: "/driving/trips",
    params: controller,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchDrivingTrip(id) {
  return axios.get(`/driving/trips/` + id);
}

export async function createDrivingTrip(payload) {
  return axios
    .post(`/driving/trips`, { trip: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
export async function updateDrivingTrip(payload) {
  return axios
    .put(`/driving/trips/${payload.id}`, { trip: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}

export async function deleteDrivingTrip(id) {
  return axios
    .delete(`/driving/trips/${id}`)

    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error;
    });
}
